module.exports = "<mat-sidenav-container>\r\n  <router-outlet></router-outlet>\r\n</mat-sidenav-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/auth-layout/auth-layout.component.html
// module id = ./src/app/core/auth-layout/auth-layout.component.html
// module chunks = main